/**
 * Convert an array of XY arrays to a DataXY object containing x,y arrays
 *
 * @param data - array of arrays [[x,y],[x,y],...]
 */
export function xy2ToXY(data) {
    const xy2 = { x: [], y: [] };
    for (let xyValue of data) {
        xy2.x.push(xyValue[0]);
        xy2.y.push(xyValue[1]);
    }
    return xy2;
}
//# sourceMappingURL=xy2ToXY.js.map